module.exports = __webpack_public_path__ + "img/case6.335ebf21.png";